<div class="max-w-5xl mx-auto p-6">
  <!-- Popup succes centree -->
  @if (successMessage) {
    <div
      class="fixed inset-0 z-50 flex items-center justify-center pointer-events-none"
    >
      <div
        class="pointer-events-auto bg-white dark:bg-slate-800 rounded-2xl shadow-2xl px-10 py-8 flex flex-col items-center gap-4 border border-green-200 dark:border-green-800 animate-[fadeInScale_0.3s_ease-out]"
      >
        <div
          class="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-4xl"
        >
          ✅
        </div>
        <p
          class="text-lg font-semibold text-gray-800 dark:text-gray-100 text-center"
        >
          {{ successMessage }}
        </p>
      </div>
    </div>
  }

  <!-- Header -->
  <div class="mb-8">
    <h1 class="text-3xl font-bold text-gray-800 dark:text-gray-100">
      Saisie manuelle des ventes
    </h1>
    <p class="text-gray-600 dark:text-gray-400 mt-2">
      Enregistrez vos ventes pour améliorer les recommandations
    </p>
  </div>

  <!-- Stepper -->
  <div class="mb-8">
    <div class="flex items-center justify-between">
      <div
        class="flex items-center"
        [class.text-blue-600]="step === 'select-date'"
        [class.font-bold]="step === 'select-date'"
      >
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center"
          [class.bg-blue-600]="step === 'select-date'"
          [class.text-white]="step === 'select-date'"
          [class.bg-gray-300]="step !== 'select-date'"
        >
          1
        </div>
        <span class="ml-2">Date & Service</span>
      </div>
      <div
        class="flex-1 h-1 mx-4 bg-gray-300"
        [class.bg-blue-600]="step !== 'select-date'"
      ></div>

      <div
        class="flex items-center"
        [class.text-blue-600]="step === 'enter-sales'"
        [class.font-bold]="step === 'enter-sales'"
      >
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center"
          [class.bg-blue-600]="step === 'enter-sales'"
          [class.text-white]="step === 'enter-sales'"
          [class.bg-gray-300]="step !== 'enter-sales'"
        >
          2
        </div>
        <span class="ml-2">Produits</span>
      </div>
      <div
        class="flex-1 h-1 mx-4 bg-gray-300"
        [class.bg-blue-600]="step === 'context' || step === 'summary'"
      ></div>

      <div
        class="flex items-center"
        [class.text-blue-600]="step === 'context'"
        [class.font-bold]="step === 'context'"
      >
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center"
          [class.bg-blue-600]="step === 'context'"
          [class.text-white]="step === 'context'"
          [class.bg-gray-300]="step !== 'context'"
        >
          3
        </div>
        <span class="ml-2">Contexte</span>
      </div>
      <div
        class="flex-1 h-1 mx-4 bg-gray-300"
        [class.bg-blue-600]="step === 'summary'"
      ></div>

      <div
        class="flex items-center"
        [class.text-blue-600]="step === 'summary'"
        [class.font-bold]="step === 'summary'"
      >
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center"
          [class.bg-blue-600]="step === 'summary'"
          [class.text-white]="step === 'summary'"
          [class.bg-gray-300]="step !== 'summary'"
        >
          4
        </div>
        <span class="ml-2">Résumé</span>
      </div>
    </div>
  </div>

  <!-- Error -->
  @if (error) {
    <div
      class="bg-red-100 dark:bg-red-900/30 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-300 px-4 py-3 rounded mb-4"
    >
      {{ error }}
    </div>
  }

  <!-- ÉTAPE 1: Sélection période + services -->
  @if (step === "select-date") {
    <div class="bg-white dark:bg-slate-800 shadow rounded-lg p-8">
      <!-- Sélection période -->
      <div class="mb-8">
        <h2 class="text-xl font-bold mb-4">📅 Sélection période</h2>
        <div class="space-y-3">
          <!-- Aujourd'hui -->
          <label
            class="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900"
            [class.border-blue-600]="periodType === 'today'"
            [class.bg-blue-50]="periodType === 'today'"
          >
            <input
              type="radio"
              name="periodType"
              value="today"
              [(ngModel)]="periodType"
              (change)="updateDateFromPeriodType()"
              class="mr-3"
            />
            <span class="font-medium">
              Aujourd'hui ({{ maxDate | date: "d MMM yyyy" : "" : "fr" }})
            </span>
          </label>
          <!-- Hier -->
          <label
            class="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900"
            [class.border-blue-600]="periodType === 'yesterday'"
            [class.bg-blue-50]="periodType === 'yesterday'"
          >
            <input
              type="radio"
              name="periodType"
              value="yesterday"
              [(ngModel)]="periodType"
              (change)="updateDateFromPeriodType()"
              class="mr-3"
            />
            <span class="font-medium">
              Hier ({{ yesterdayDate | date: "d MMM yyyy" : "" : "fr" }})
            </span>
          </label>
          <!-- Période personnalisée -->
          <div
            class="border dark:border-slate-600 rounded-lg"
            [class.border-blue-600]="periodType === 'custom'"
            [class.bg-blue-50]="periodType === 'custom'"
          >
            <label class="flex items-center p-4 cursor-pointer">
              <input
                type="radio"
                name="periodType"
                value="custom"
                [(ngModel)]="periodType"
                class="mr-3"
              />
              <span class="font-medium">Période personnalisée:</span>
            </label>
            @if (periodType === "custom") {
              <div class="px-4 pb-4 flex items-center gap-4">
                <div>
                  <label class="text-sm text-gray-600 dark:text-gray-400"
                    >Du:</label
                  >
                  <input
                    type="date"
                    [(ngModel)]="customPeriod.from"
                    [max]="maxDate"
                    class="ml-2 p-2 border dark:border-slate-600 rounded dark:bg-slate-700 dark:text-white"
                  />
                </div>
                <div>
                  <label class="text-sm text-gray-600 dark:text-gray-400"
                    >Au:</label
                  >
                  <input
                    type="date"
                    [(ngModel)]="customPeriod.to"
                    [max]="maxDate"
                    class="ml-2 p-2 border dark:border-slate-600 rounded dark:bg-slate-700 dark:text-white"
                  />
                </div>
              </div>
            }
          </div>
        </div>
        <p class="text-sm text-gray-600 dark:text-gray-400 mt-3">
          ℹ️ Vous pouvez saisir plusieurs jours en une fois
        </p>
      </div>
      <!-- Sélection services -->
      <div class="mb-8">
        <h2 class="text-xl font-bold mb-4">🕐 Services concernés</h2>
        <div class="space-y-3">
          @for (service of availableServices; track service) {
            <label
              class="flex items-center justify-between p-4 border rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-700 dark:bg-slate-900"
              [class.border-blue-600]="service.checked"
              [class.bg-blue-50]="service.checked"
            >
              <div class="flex items-center">
                <input
                  type="checkbox"
                  [checked]="service.checked"
                  (change)="toggleService(service.id)"
                  class="mr-3 w-5 h-5"
                />
                <div>
                  <span class="font-medium">{{ service.label }}</span>
                  <span class="ml-2 text-gray-600 dark:text-gray-400">{{
                    service.name
                  }}</span>
                </div>
              </div>
              @if (!service.checked) {
                <span class="text-sm text-gray-500 dark:text-gray-400">
                  Non ouvert ce jour
                </span>
              }
            </label>
          }
        </div>
        <p class="text-sm text-gray-600 dark:text-gray-400 mt-3">
          💡 Décochez si service non réalisé
        </p>
      </div>
      <div class="mt-8 flex justify-end space-x-4">
        <button
          (click)="cancel()"
          class="px-6 py-2 border border-gray-300 dark:border-slate-600 rounded hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800"
        >
          Annuler
        </button>
        <button
          (click)="proceedToSalesEntry()"
          [disabled]="selectedServices.length === 0 || loading"
          class="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          @if (loading) {
            <span>Chargement...</span>
          }
          @if (!loading) {
            <span>Continuer</span>
          }
        </button>
      </div>
    </div>
  }

  <!-- ÉTAPE 2: Saisie produits -->
  @if (step === "enter-sales") {
    <div class="bg-white dark:bg-slate-800 shadow rounded-lg p-8">
      <h2 class="text-2xl font-bold mb-2">Saisie des quantités</h2>
      <p class="text-gray-600 dark:text-gray-400 mb-4">
        {{ selectedDate | date: "fullDate" : "" : "fr" }}
      </p>
      <!-- Accordéons par service -->
      <div class="space-y-3">
        @for (serviceId of selectedServices; track serviceId; let i = $index) {
          <div class="border dark:border-slate-600 rounded-lg">
            <!-- En-tête accordéon -->
            <button
              (click)="toggleAccordion(serviceId)"
              class="w-full px-4 py-3 flex items-center justify-between bg-gray-50 dark:bg-slate-900 hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 rounded-t-lg"
              [class.rounded-b-lg]="expandedService !== serviceId"
            >
              <div class="flex items-center space-x-2">
                <span class="text-lg font-semibold">{{ serviceId }}</span>
                <span class="text-sm text-gray-500 dark:text-gray-400">
                  ({{ getProductsForService(serviceId).length }} produits)
                </span>
              </div>
              <svg
                class="w-5 h-5 transform transition-transform"
                [class.rotate-180]="expandedService === serviceId"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            <!-- Contenu accordéon -->
            @if (expandedService === serviceId) {
              <div class="border-t">
                <div class="max-h-96 overflow-y-auto">
                  <table class="w-full">
                    <thead class="bg-gray-50 dark:bg-slate-900 sticky top-0">
                      <tr>
                        <th
                          class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase"
                        >
                          Produit
                        </th>
                        <th
                          class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase"
                        >
                          Recommandé
                        </th>
                        <th
                          class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase"
                        >
                          Préparé
                        </th>
                        <th
                          class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase"
                        >
                          Vendu
                        </th>
                        <th
                          class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase"
                        >
                          Gaspillé
                        </th>
                        <th
                          class="px-3 py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase"
                        >
                          Rupture
                        </th>
                        <th
                          class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      class="divide-y divide-gray-200 dark:divide-slate-700"
                    >
                      @for (
                        product of getProductsForService(serviceId);
                        track product
                      ) {
                        <tr>
                          <td class="px-3 py-2 font-medium text-sm">
                            {{ product.productName }}
                          </td>
                          <td
                            class="px-3 py-2 text-gray-500 dark:text-gray-400 text-sm"
                          >
                            {{ product.recommended || "-" }}
                          </td>
                          <td class="px-3 py-2">
                            <input
                              type="number"
                              [(ngModel)]="product.prepared"
                              (ngModelChange)="onPreparedOrSoldChange(product)"
                              min="0"
                              class="w-16 px-2 py-1 text-sm border border-gray-300 dark:border-slate-600 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                            />
                          </td>
                          <td class="px-3 py-2">
                            <div class="flex flex-col">
                              <input
                                type="number"
                                [(ngModel)]="product.sold"
                                (ngModelChange)="
                                  onPreparedOrSoldChange(product)
                                "
                                min="0"
                                [max]="product.prepared"
                                placeholder="-"
                                [class.border-red-500]="
                                  product.sold != null &&
                                  product.sold > product.prepared
                                "
                                class="w-16 px-2 py-1 text-sm border border-gray-300 dark:border-slate-600 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                              />
                              @if (
                                product.sold != null &&
                                product.sold > product.prepared
                              ) {
                                <span
                                  class="text-xs text-red-600 dark:text-red-400 mt-1"
                                >
                                  Max: {{ product.prepared }}
                                </span>
                              }
                            </div>
                          </td>
                          <td class="px-3 py-2">
                            <input
                              type="number"
                              [(ngModel)]="product.wasted"
                              min="0"
                              placeholder="-"
                              class="w-16 px-2 py-1 text-sm border border-gray-300 dark:border-slate-600 rounded bg-gray-50 dark:bg-slate-900"
                            />
                          </td>
                          <td class="px-3 py-2 text-center">
                            <input
                              type="checkbox"
                              [(ngModel)]="product.hasRupture"
                              class="w-4 h-4"
                            />
                          </td>
                          <td class="px-3 py-2">
                            <div class="flex flex-wrap gap-1">
                              <button
                                type="button"
                                (click)="setSoldToPrepared(product)"
                                [disabled]="product.prepared === 0"
                                class="px-2 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed whitespace-nowrap"
                                title="Marquer comme tout vendu"
                              >
                                Tout vendu
                              </button>
                              <button
                                type="button"
                                (click)="setExhausted(product)"
                                [disabled]="product.prepared === 0"
                                class="px-2 py-1 text-xs bg-orange-600 text-white rounded hover:bg-orange-700 disabled:bg-gray-300 disabled:cursor-not-allowed whitespace-nowrap"
                                title="Marquer comme épuisé avec rupture"
                              >
                                Épuisé
                              </button>
                              <div class="flex gap-1">
                                <button
                                  type="button"
                                  (click)="setRemaining(product, 10)"
                                  [disabled]="product.prepared === 0"
                                  class="px-1.5 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                                  title="Il reste 10% (90% vendu)"
                                >
                                  -10%
                                </button>
                                <button
                                  type="button"
                                  (click)="setRemaining(product, 20)"
                                  [disabled]="product.prepared === 0"
                                  class="px-1.5 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                                  title="Il reste 20% (80% vendu)"
                                >
                                  -20%
                                </button>
                                <button
                                  type="button"
                                  (click)="setRemaining(product, 30)"
                                  [disabled]="product.prepared === 0"
                                  class="px-1.5 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                                  title="Il reste 30% (70% vendu)"
                                >
                                  -30%
                                </button>
                                <button
                                  type="button"
                                  (click)="setRemaining(product, 40)"
                                  [disabled]="product.prepared === 0"
                                  class="px-1.5 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                                  title="Il reste 40% (60% vendu)"
                                >
                                  -40%
                                </button>
                                <button
                                  type="button"
                                  (click)="setRemaining(product, 50)"
                                  [disabled]="product.prepared === 0"
                                  class="px-1.5 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                                  title="Il reste 50% (50% vendu)"
                                >
                                  -50%
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="mt-8 flex justify-between">
        <button
          (click)="goBack()"
          class="px-6 py-2 border border-gray-300 dark:border-slate-600 rounded hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800"
        >
          Retour
        </button>
        <div class="space-x-4">
          <button
            (click)="saveDraft()"
            [disabled]="loading"
            class="px-6 py-2 border border-blue-600 text-blue-600 dark:text-blue-400 rounded hover:bg-blue-50 dark:bg-blue-900/20 disabled:opacity-50"
          >
            Sauvegarder brouillon
          </button>
          <button
            (click)="proceedToContext()"
            class="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Continuer
          </button>
        </div>
      </div>
    </div>
  }

  <!-- ÉTAPE 3: Contexte -->
  @if (step === "context") {
    <div class="bg-white dark:bg-slate-800 shadow rounded-lg p-8">
      <h2 class="text-2xl font-bold mb-6">Informations contextuelles</h2>
      <div class="space-y-6">
        <!-- Context flags -->
        <div>
          <label
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3"
            >Facteurs exceptionnels</label
          >
          <div class="grid grid-cols-2 gap-4">
            <label class="flex items-center space-x-2">
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.ruptureStock"
                class="w-5 h-5"
              />
              <span>Rupture de stock</span>
            </label>
            <label class="flex items-center space-x-2">
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.unusualAffluence"
                class="w-5 h-5"
              />
              <span>Affluence inhabituelle</span>
            </label>
            <label class="flex items-center space-x-2">
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.weatherImpact"
                class="w-5 h-5"
              />
              <span>Météo impactante</span>
            </label>
            <label class="flex items-center space-x-2">
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.localEvent"
                class="w-5 h-5"
              />
              <span>Événement local</span>
            </label>
            <label class="flex items-center space-x-2">
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.technicalIssue"
                class="w-5 h-5"
              />
              <span>Problème technique</span>
            </label>
            <label class="flex items-center space-x-2">
              <input
                type="checkbox"
                [(ngModel)]="contextFlags.differentLocation"
                class="w-5 h-5"
              />
              <span>Emplacement différent</span>
            </label>
          </div>
        </div>
        <!-- Affluence -->
        <div>
          <label
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >Affluence réelle</label
          >
          <select
            [(ngModel)]="actualAttendance"
            class="w-full p-3 border border-gray-300 dark:border-slate-600 rounded"
          >
            <option value="">Non spécifié</option>
            <option value="low">Faible</option>
            <option value="medium">Moyen</option>
            <option value="high">Élevé</option>
          </select>
        </div>
        <!-- Météo -->
        <div>
          <label
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >Météo réelle</label
          >
          <select
            [(ngModel)]="actualWeather"
            class="w-full p-3 border border-gray-300 dark:border-slate-600 rounded"
          >
            <option value="">Non spécifié</option>
            <option value="sunny">Ensoleillé</option>
            <option value="cloudy">Nuageux</option>
            <option value="rainy">Pluvieux</option>
            <option value="stormy">Orageux</option>
          </select>
        </div>
        <!-- Notes -->
        <div>
          <label
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >Notes (optionnel)</label
          >
          <textarea
            [(ngModel)]="notes"
            rows="4"
            placeholder="Ajoutez des notes sur cette journée..."
            class="w-full p-3 border border-gray-300 dark:border-slate-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
          </textarea>
        </div>
      </div>
      <div class="mt-8 flex justify-between">
        <button
          (click)="goBack()"
          class="px-6 py-2 border border-gray-300 dark:border-slate-600 rounded hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800"
        >
          Retour
        </button>
        <button
          (click)="proceedToSummary()"
          class="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Voir le résumé
        </button>
      </div>
    </div>
  }

  <!-- ÉTAPE 4: Résumé -->
  @if (step === "summary") {
    <div class="bg-white dark:bg-slate-800 shadow rounded-lg p-8">
      <h2 class="text-2xl font-bold mb-6">Résumé et validation</h2>
      <!-- Info général -->
      <div class="mb-6 p-4 bg-gray-50 dark:bg-slate-900 rounded">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <span class="font-medium">Date:</span>
            {{ selectedDate | date: "fullDate" : "" : "fr" }}
          </div>
          <div>
            <span class="font-medium">Service(s):</span>
            {{ selectedServices.join(", ") }}
          </div>
        </div>
      </div>
      <!-- Totaux -->
      <div class="grid grid-cols-4 gap-4 mb-6">
        <div class="p-4 bg-blue-50 dark:bg-blue-900/20 rounded text-center">
          <div class="text-2xl font-bold text-blue-600 dark:text-blue-400">
            {{ getTotalPrepared() }}
          </div>
          <div class="text-sm text-gray-600 dark:text-gray-400">
            produits préparés
          </div>
        </div>
        <div class="p-4 bg-green-50 dark:bg-green-900/20 rounded text-center">
          <div class="text-2xl font-bold text-green-600 dark:text-green-400">
            {{ getTotalSold() }}
          </div>
          <div class="text-sm text-gray-600 dark:text-gray-400">
            produits vendus <span class="text-xs text-gray-400">(qte)</span>
          </div>
          @if (getTotalRevenue() > 0) {
            <div class="text-xs font-semibold text-green-500 mt-1">
              &asymp; {{ getTotalRevenue() | number: "1.0-0" }} &euro; CA
            </div>
          }
        </div>
        <div class="p-4 bg-red-50 dark:bg-red-900/20 rounded text-center">
          <div class="text-2xl font-bold text-red-600 dark:text-red-400">
            {{ getTotalWasted() }}
          </div>
          <div class="text-sm text-gray-600 dark:text-gray-400">
            produits gaspiés <span class="text-xs text-gray-400">(qte)</span>
          </div>
          @if (getTotalWasteValue() > 0) {
            <div class="text-xs font-semibold text-red-400 mt-1">
              &asymp; {{ getTotalWasteValue() | number: "1.0-0" }} &euro; perdus
            </div>
          }
        </div>
        <div class="p-4 bg-orange-50 dark:bg-orange-900/20 rounded text-center">
          <div
            class="text-2xl font-bold"
            [class.text-orange-600]="getTotalRuptures() > 0"
            [class.text-gray-400]="getTotalRuptures() === 0"
          >
            {{ getTotalRuptures() }}
          </div>
          <div class="text-sm text-gray-600 dark:text-gray-400">
            rupture(s) <span class="text-xs text-gray-400">(produits)</span>
          </div>
        </div>
      </div>
      <!-- Facteurs -->
      @if (
        contextFlags.ruptureStock ||
        contextFlags.unusualAffluence ||
        contextFlags.weatherImpact ||
        contextFlags.localEvent ||
        contextFlags.technicalIssue ||
        contextFlags.differentLocation
      ) {
        <div
          class="mb-6 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded"
        >
          <h3 class="font-medium mb-2">Facteurs exceptionnels:</h3>
          <ul class="list-disc list-inside space-y-1 text-sm">
            @if (contextFlags.ruptureStock) {
              <li>Rupture de stock</li>
            }
            @if (contextFlags.unusualAffluence) {
              <li>Affluence inhabituelle</li>
            }
            @if (contextFlags.weatherImpact) {
              <li>Météo impactante</li>
            }
            @if (contextFlags.localEvent) {
              <li>Événement local</li>
            }
            @if (contextFlags.technicalIssue) {
              <li>Problème technique</li>
            }
            @if (contextFlags.differentLocation) {
              <li>Emplacement différent</li>
            }
          </ul>
        </div>
      }
      <div class="mt-8 flex justify-between">
        <button
          (click)="goBack()"
          class="px-6 py-2 border border-gray-300 dark:border-slate-600 rounded hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800"
        >
          Retour
        </button>
        <button
          (click)="submit()"
          [disabled]="loading"
          class="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          @if (loading) {
            <span>Enregistrement...</span>
          }
          @if (!loading) {
            <span>✓ Valider et enregistrer</span>
          }
        </button>
      </div>
    </div>
  }
</div>
